import { borderRadius, height } from "@mui/system";
import colors from "../../scss/colors";

export const textFieldStyles = {
    backgroundColor: 'white',
    height: '40px',
    borderRadius: '20px',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '20px',
    '& .MuiInputBase-input.MuiOutlinedInput-input': {
        height: '18px',
        padding: '12px 14px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        border: '0',
        borderRadius: '10px',
        padding: '12px'
    },
    color: colors.BLACK_TXT,
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '17px',
    fieldset: {
        legend: {
            width: '100%'
        }
    }
};

export const labelStyle = { fontSize: '14px', color: colors.DARKEST_GREY };
